import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { opportunitiesRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const OpportunitiesPage = () =>
  import(
    /* webpackChunkName: "opportunities" */ '@/pmd/pages/OpportunitiesPage.vue'
  ).then(m => m.default)

const BulkActionsImportPage = () =>
    import('@/pmd/pages/bulk-actions/BulkActions.vue').then(m => m.default)

const PipelineSettings = () =>
  import(
    /* webpackChunkName: "location-pipeline-settings" */ '@/pmd/pages/settings/PipelineSettings.vue'
  ).then(m => m.default)

const BulkActionsOpportunityPage = () =>
  import(
    /* webpackChunkName: "customer-imports" */ '@/pmd/pages/bulk-actions/BulkActionsOpportunityPage.vue'
  ).then(m => m.default)

export const opportunitiesRoute: RouteConfig[] = [
  {
    path: 'opportunities',
    name: opportunitiesRouteNames.default,
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'list',
        name: opportunitiesRouteNames.list,
        component: OpportunitiesPage,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: ':id',
            name: opportunitiesRouteNames.byId,
            component: OpportunitiesPage,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'pipeline',
        name: opportunitiesRouteNames.pipeline,
        component: PipelineSettings,
        meta: { translations: [Modules.PipelineSettings] },
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'import',
        name: opportunitiesRouteNames.import,
        component: BulkActionsImportPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'bulk-actions',
        name: opportunitiesRouteNames.BulkActions,
        component: BulkActionsOpportunityPage,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  },
]